export enum AnalyticsQueryTypes {
  ENGAGEMENT = "engagement",
  COUNTS = "counts",
  DSPS = "dsps",
  SONGS = "songs",
  AGE = "age",
  GENDER = "gender",
  LOCATIONS = "locations",
}
